import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { ProjectFormMode } from '../enums/project-rate-form-mode.enum';

export const manageProjectWagesGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const formState = route.paramMap.get('formMode');

  if (
    !formState ||
    !Object.values(ProjectFormMode).includes(formState as ProjectFormMode)
  ) {
    return router.createUrlTree([
      '/setup/prevailing-wage-setup/manage-project-wage-data',
    ]);
  }

  return true;
};
